import React, {useState} from 'react';
import {Container, Image, Nav, Navbar} from 'react-bootstrap';
import {Link, Outlet} from 'react-router-dom';
import LocalDataService from "../../api/LocalDataService";

// 左侧导航栏数据
const menuItems = [
    {key: 'cozeList/', title: '智能体集合', icon: 'coze_menu_icon_1.svg', iconSize: '26px'},
    // {key: 'cozeList/CopyTaskList', title: '复制任务列表', icon: 'coze_menu_icon_2.svg', iconSize: '20px'},
    // {key: 'cozeList/CozeSpace', title: '我的Coze空间', icon: 'coze_menu_icon_3.svg', iconSize: '20px'},
];


export default function WorkFlowReplication({userProfileRef}) {
    // 获取当前屏幕宽度
    const [isMobile, setIsMobile] = React.useState(false);
    const [activeKey, setActiveKey] = useState(null);

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };
        setActiveKey(menuItems[0].key)
        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);
        let user_info = LocalDataService.load_user_data();
        let loginData = LocalDataService.load_login_data();
        // 假设 LocalDataService 中有一个方法来检查用户是否已登录
        if (!user_info || !loginData) {
            userProfileRef.current.showLoginModal(false);
            // 如果用户未登录，重定向到登录页面
        }
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

// 提取菜单项组件
    const MenuItem = ({item}) => (
        <Nav.Link key={item.key} as={Link} to={`/${item.key}`}
                  isActive={activeKey === item.key}
                  onClick={() => setActiveKey(item.key)}
                  style={{
                      width: '100%',
                      color: '#fff',
                      padding: '1rem 1.5rem',
                      marginTop: '8px',
                      textAlign: 'left',
                      borderLeftColor: 'transparent',
                      borderWidth: '8px',
                      borderLeftStyle: 'solid',
                      backgroundColor: activeKey === item.key ? '#282E38' : 'transparent',
                      borderImage: activeKey === item.key ? ' linear-gradient( 180deg, #A534E3 0%, #02C8E3 100%) 2' : 'none',
                  }}>
            <Image src={`/images/coze/${item.icon}`}
                   style={{width: item.iconSize, height: item.iconSize, marginRight: '8px'}}/>
            {item.title}
        </Nav.Link>
    );

    return (
        <div>
            {/* 主要内容区域 */}
            <Container fluid style={{padding: '24px 16px'}}>
                {/* 左侧或顶部导航栏 */}
                {isMobile ? (
                    <Navbar variant="dark" expand="md" className="flex-column mb-4 align-items-start" style={{borderTopLeftRadius: '20px',borderTopRightRadius: '20px',padding:'0px',backgroundColor:'#1E2129'}}>
                        <Navbar.Brand href="#" className={'text-center w-100 mb-3'} style={{background:"#282E38",borderTopLeftRadius: '20px',borderTopRightRadius: '20px',padding:'23px'}}>智能体执行</Navbar.Brand>
                        <Nav className="mr-auto w-100">
                            {menuItems.map(item => <MenuItem item={item}/>)}</Nav>
                    </Navbar>
                ) : (
                    <Navbar className="flex-column"  variant="dark" expand="md"
                            style={{height: '100vh', position: 'fixed', width: '260px', alignItems: 'start',borderTopLeftRadius: '20px',borderTopRightRadius: '20px',padding:'0px',backgroundColor:'#1E2129'}}>
                        <Navbar.Brand href="#" className={'text-center w-100 mb-3'} style={{background:"#282E38",borderTopLeftRadius: '20px',borderTopRightRadius: '20px',padding:'23px'}}>智能体执行</Navbar.Brand>
                        <Nav className="flex-column w-100">
                            {menuItems.map(item => (
                                <MenuItem item={item}/>
                            ))}
                        </Nav>
                    </Navbar>
                )}
                <div style={{marginLeft: isMobile ? '0' : '280px'}}>
                    <Outlet/>
                </div>
            </Container>
        </div>
    );
}